export function fastFormSubmit(state = null, action) {
  switch (action.type) {
    default:
      return state;
  }
}
